import { useEffect } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { createBrowserRouter, RouterProvider } from 'react-router'

import { SettingsProvider } from './core/settings'
import useSettings from './core/useSettings'
import HomePage from './pages/HomePage'
import VerificationIdentityCreatePage from './pages/VerificationIdentityCreatePage'
import VerificationEmailPage from './pages/VerificationEmailPage'
import VerificationIdentityEditPage from './pages/VerificationIdentityEditPage'
import VerificationPhonePage from './pages/VerificationPhonePage'
import VerificationPage from './pages/VerificationPage'
import VerificationReviewPage from './pages/VerificationReviewPage'
import VerificationStatusPage from './pages/VerificationStatusPage'
import ThemeProvider from './theme'
import './App.css'

const router = createBrowserRouter([
  { path: '/', element: <HomePage /> },
  { path: '/verify/:verificationToken', element: <VerificationPage /> },
  { path: '/verify/:verificationToken/email', element: <VerificationEmailPage /> },
  { path: '/verify/:verificationToken/phone', element: <VerificationPhonePage /> },
  { path: '/verify/:verificationToken/review', element: <VerificationReviewPage /> },
  { path: '/verify/:verificationToken/status', element: <VerificationStatusPage /> },
  { path: '/verify/:verificationToken/edit', element: <VerificationIdentityEditPage /> },
  { path: '/verify/:verificationToken/create', element: <VerificationIdentityCreatePage /> },
  { path: '*', element: <HomePage /> },
])

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
})

function AppContent() {
  const { mode } = useSettings()
  const { i18n, t } = useTranslation()

  useEffect(() => {
    document.title = t('documentTitle')
  }, [i18n.language, t])

  return (
    <ThemeProvider mode={mode}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </ThemeProvider>
  )
}

export default function App() {
  return (
    <SettingsProvider>
      <AppContent />
    </SettingsProvider>
  )
}
